<template>
  <div class="project">
    <el-form :inline="true" :model="siftForm" class="demo-form-inline" size="small" @submit.native.prevent v-if="isShowFormInline">
      <el-form-item>
        <span slot="label">
          <strong>名称</strong>
        </span>
        <el-input
          v-model="siftForm.name"
          placeholder="请输入名称"
          clearable
          @keyup.enter.native="inquire"
          @clear="inquire"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" style="background:#0C75E5" @click="inquire">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="header">
      <!-- <div class="title">项目列表</div> -->
      <div>
        <el-tooltip class="item" effect="dark" :content="isShowFormInline ? '隐藏搜索' : '显示搜索'" placement="top-end">
          <el-button class="hidden" icon="el-icon-search" @click="isShowFormInline = !isShowFormInline"></el-button>
        </el-tooltip>
      </div>
    </div>
    <!-- 块形式 -->
    <div class="item" v-loading="loading">
      <div style="text-align:center;color:#999" v-if="!showList.length">暂无数据</div>
      <el-card
        shadow="always"
        v-for="(item, index) in showList"
        :key="index"
        :class="(index + 1) % 4 == 0 ? 'noright' : ''"
        @click.native="handleDetail(item)"
        :body-style="{padding: '10px'}"
        v-if="item"
      >
        <div class="line">
          <span class="text-left">分享给:</span>
          <span class="text-right">{{item.toUserName}}</span>
        </div>
        <div class="line">
          <div class="line-left">编码:</div>
          <div class="line-right">{{ item.resourceNumber }}</div>
        </div>
        <div class="line">
          <div class="line-left">描述:</div>
          <div class="line-right">{{ item.remarks }}</div>
        </div>
        <div class="line">
          <div class="line-left">名称:</div>
          <div class="line-right">{{ item.resourceName }}</div>
        </div>
        <div class="line">
          <div class="line-left">规格型号:</div>
          <div class="line-right">{{ item.ggxh }}</div>
        </div>
        <div class="line">
          <div class="line-left">计量单位:</div>
          <div class="line-right">{{ item.jldw }}</div>
        </div>
        <i class="iconfont icon-yidu iconStatus" v-if="item.isView == '1'"></i>
        <i class="iconfont icon-weidu1 iconStatus" v-else></i>
      </el-card>
    </div>
    <div class="bottom">
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[8, 16, 24, 32]"
        :page-size="pageSize"
        layout="->, prev, pager, next, sizes, jumper, total"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog v-dialog-drag
               title="查看详情"
               :visible.sync="resourceDialog"
               :append-to-body="true"
    >
      <el-form
        :model="ruleFormRes"
        ref="ruleFormRes"
        class="demo-ruleFormRes"
        style="max-height: 50vh; overflow-y: auto;overflow-x: hidden"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="resourceName">
              <el-input
                v-model="ruleFormRes.resourceName"
                :placeholder="'请输入' + resData.restypeName + '名称'"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isPrivate == '0'">
            <el-form-item label="归属人" prop="userId">
              <el-select v-model="ruleFormRes.userId" placeholder="请选择归属人" style="width:97%" filterable>
                <el-option-group
                  v-for="group in userList"
                  :key="group.ofrResourceId"
                  :label="group.resourceName">
                  <el-option
                    v-for="item in group.ofrThingList"
                    :key="item.ofrThingId"
                    :label="item.name"
                    :value="item.ofrThingId">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="销售价" prop="rprice">
              <el-input
                v-model="ruleFormRes.rprice"
                placeholder="请输入销售价"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="成本价" prop="cprice">
              <el-input
                v-model="ruleFormRes.cprice"
                placeholder="请输入成本价"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="税率" prop="rslv">

              <el-select v-model="ruleFormRes.rslv" placeholder="请选择税率" style="width:97%" clearable>
                <el-option
                  v-for="item in dropDown.invoiceVat"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="规格型号" prop="ggxh">
              <el-input
                v-model="ruleFormRes.ggxh"
                placeholder="请输入规格型号"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="单位" prop="jldw">
              <el-input
                v-model="ruleFormRes.jldw"
                placeholder="请输入单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="双计系数" prop="sjxs">
              <el-input
                type="number"
                v-model="ruleFormRes.sjxs"
                placeholder="请输入双计系数"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="双计单位" prop="sjdw">
              <el-input
                v-model="ruleFormRes.sjdw"
                placeholder="请输入双计单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 伙伴-额度管理 -->
          <el-col :span="12" v-if="resData.kind == '7' && resData.edgl == '0'">
            <el-form-item label="额度" prop="edje">
              <el-input
                v-model="ruleFormRes.edje"
                placeholder="请输入额度"
                style="width: 97%"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '7' && resData.edgl == '0' && judgeButton('lsed')">
            <el-form-item label="临时额度" prop="lsed">
              <el-input
                v-model="ruleFormRes.lsed"
                placeholder="请输入临时额度"
                style="width: 97%"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12" v-if="resData.kind == '7' && resData.edgl == '0'">
            <el-form-item label="额度活动" prop="edid">
              <treeselect v-model="ruleFormRes.edid" :options="cflowItemTree" :normalizer="normalizer1" placeholder="请选择额度活动" :disable-branch-nodes="true" :flat="true" :appendToBody="true" z-index="9000" />
            </el-form-item>
          </el-col> -->
          <!-- 伙伴-账期管理 -->
          <el-col :span="12" v-if="resData.kind == '7' && resData.zqgl == '0'">
            <el-form-item label="账期天数" prop="zqts">
              <el-input
                v-model="ruleFormRes.zqts"
                placeholder="请输入账期天数"
                style="width: 97%"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12" v-if="resData.kind == '7' && resData.zqgl == '0'">
            <el-form-item label="账期活动" prop="zqid">
              <treeselect v-model="ruleFormRes.zqid" :options="cflowItemTree" :normalizer="normalizer1" placeholder="请选择账期活动" :disable-branch-nodes="true" :flat="true" :appendToBody="true" z-index="9000"/>
            </el-form-item>
          </el-col> -->
        </el-row>
        <Form :formList="formList" :gutter="20" :ruleForm="ruleFormRes"/>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleEditShareStatus">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import url from '@/config/url'
import qs from 'qs'
import Form from '@/components/Form.vue'
export default {
  components: {
    Form
  },
  computed: {
    ...mapState({
      dropDown: (state) => state.dropDown.dropDown
    })
  },
  data() {
    return {
      siftForm: {
        name: '',
      },
      formList:[],
      pageSize: 8,
      currentPage: 1,
      // 总条数，总共有多少条数据
      total: 0,
      total_money: 0,
      resourceDialog: false,
      ruleFormRes: {
      },
      resData:{},
      // 展示的数据
      showList: [],
      loading: true,
      dialogShareVisible: false,
      form: {
        toUserIds: [],
        obussId: ''
      },
      userList: [],
      isShowFormInline: false,
      dialogVisible: false,
      btnMenu: JSON.parse(window.sessionStorage.getItem('btnMenu'))
    }
  },
  created () {
    this.getList()
    this.$http.get(url.getPostAndUserList).then(res => {
      if (res.data.code == 200) {
        this.userList = res.data.data
      }
    })
  },

  methods: {
    handleDetail(row){
      this.$http.get(url.getOfrResource, { params: { ofrResourceId: row.ofrResourceId } }).then(res => {
        const data = res.data.data.ofrResource
        this.resData = res.data.data.cbResourceType
        for (const key in data) {
          this.ruleFormRes[key] = data[key]
        }
        this.formList = this.handleFormList(res.data.data.dimensionList)
        this.ruleFormRes.dataSourceConfig = this.formList
        this.resourceDialog = true
      })
    },
    handleEditShareStatus(){
      this.resourceDialog = false
    },
    judgeButton (type) {
      return this.btnMenu.some(item => item.perms === `${this.currentMenu.kind}:${type}`)
    },
    // 发送请求，获取项目列表
    getList() {
      this.$http.get(url.getMyShareList, {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          name: this.siftForm.name,
          flowType: 'r'
        }
      }).then(res => {
        this.loading = false
        if(res.data.code == 200) {
          this.showList = res.data.data.list
          this.total = res.data.data.total;
        }
      })
    },
    // 查询按钮
    inquire() {
      this.currentPage = 1
      this.loading = true
      this.getList()
    },
    // 重置按钮
    reset() {
      this.currentPage = 1
      this.siftForm.name = ''
      this.loading = true
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1
      this.loading = true
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loading = true
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.project {
  .header {
    display: flex;
    justify-content: flex-end;
    .hidden {
      padding: 6px;
      border-radius: 50%;
      margin-bottom: 0 !important;
    }
    /* .tab {
      padding: 0;
      border: 0;
      font-size: 18px;
      margin-bottom: 16px;
    } */
  }
  .el-table {
    margin-bottom: 39px;
  }
  .item {
    overflow: hidden;
    /* margin-bottom: 39px; */
    .el-card {
      width: calc(25% - 14px);
      float: left;
      margin-bottom: 16px;
      margin-right: 16px;
      position: relative;
      cursor: pointer;
      ::v-deep .el-card__header {
        padding: 10px 10px 10px 20px;
      }
      .clearfix {
        display: flex;
        justify-content: space-between;
        align-items: center;
        >span {
          display: inline-block;
          width: 80%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .line {
        font-size: 13px;
        margin-bottom: 6px;
        width: 98%;
        display: flex;
        margin-left: 8px;
        .line-left {
          margin-right: 5px;
        }
        .line-right {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .last-line {
        display: flex;
        justify-content: flex-end;
      }
      .view {
        padding: 6px 10px;
        font-size: 12px;
        background-color: #0c75e5;
        color: #fff;
        border: 0;
      }
      .iconStatus {
        position: absolute;
        bottom: 40px;
        right: 10px;
        font-size: 50px;
      }
      .icon-yidu {
        color: #67c23a;
      }
      .icon-weidu1 {
        color: #f56c6c;
      }
    }
    .noright {
      margin-right: 0;
    }
  }
  .title {
    height: 16px;
    font-size: 16px;
    font-family: STHeitiSC-Medium, STHeitiSC;
    font-weight: 500;
    color: #282828;
    line-height: 16px;
    padding-left: 8px;
    border-left: #0c75e5 2px solid;
    margin-bottom: 16px;
    font-weight: bolder;
    margin-top: 16px;
  }
}
::v-deep .el-dialog {
  margin: 0 auto;
  max-height: calc(100% - 72px);
}
::v-deep .el-dialog__body {
  padding: 10px 20px 10px 20px;
  max-height: calc(100vh - 206px);
  overflow: auto;
}
</style>
